<template lang="pug">
.tabela-dados
    h3.denuncia-inserir__titulo {{ translate('titulo_tabela') }}
    el-table.tabela-dados__table(
        :data='listaDados.data',
        stripe,
        show-overflow-tooltip,
        style='width: 100%',
        @selection-change='handleSelectionChange',
        @sort-change='handleSortChangeData'
    )
        el-table-column(v-if='!state.resultado', type='selection', width='55')
        el-table-column(
            prop='label',
            sortable='custom',
            :label='translate("table_col_cpf_cnpj_car")'
        )
            template(slot-scope='scope')
                span {{ scope.row.label || '-' }}
        template(slot='empty')
            el-empty.tabela-dados__empyt(
                :description='translate("table_vazio")'
            )
    #denuncia-listagem-resultado.paginacao(v-if='!state.exportando')
        span.total-paginas {{ formatarTotalPaginas(listaDados.totalItens) }}
        el-pagination(
            size='small',
            layout='prev, pager, next',
            :page-size='state.itensPorPagina === 1 ? listaDados.data.length : state.itensPorPagina',
            :total='listaDados.totalItens',
            :page-count='listaDados.totalPaginas',
            @current-change='mudarPaginaDados'
        )
    .acoes(v-if='!state.resultado')
        .acoes__remover(@click='confirmarRemocao')
            i.el-icon-delete.acoes__icon
            span.button__text {{ formatarRemover() }}
        button.denuncia-inserir__button(@click='consultarDados')
            i.lyra-icon.lyra-grafico.acoes__icon.acoes__icon--consulta
            span.button__text {{ $t('denuncia.view.labels.inserir_denucia.consultar') }}

    .denuncia-resultado(
        v-if='state.resultado == "Negativo"',
        style='margin-top: 20px'
    )
        .denuncia-resultado__mensagem(
            :class='{ "denuncia-resultado__mensagem--negativo": !state.quantidadeResultados, "denuncia-resultado__mensagem--positivo": !!state.quantidadeResultados }'
        )
            i.mdi(
                :class='{ "mdi-check-circle-outline": !state.quantidadeResultados, "mdi-alert-circle-outline": !!state.quantidadeResultados }'
            )
            span(
                v-html='formatarMensagemResultado(state.quantidadeResultados)'
            )

    .acoes(v-if='state.resultado == "Negativo"')
        .acoes__remover
        button.denuncia-inserir__button(@click='retornarListagem')
            i.voltar.mdi.mdi-arrow-left
            span.button__text {{ $t('denuncia.view.buttons.retornar') }}
</template>
<script>
import { defineComponent } from 'vue';
import useShareReportInsert from '@/modules/denuncia/composition/useShareReportInsert';
import useShareReport from '@/modules/denuncia/composition/useShareReport';
import services from '@/modules/denuncia/services/DenunciaService';
import { formatarMensagemResultado } from '@/modules/denuncia/mixins';

export default defineComponent({
    setup() {
        const {
            state,
            translate,
            listaDados,
            handleSortChangeData,
            mudarPaginaDados,
            confirmarRemocao,
            handleSelectionChange,
            notifyError
        } = useShareReportInsert();
        const { adicionarResultado } = useShareReport();

        const formatarRemover = () =>
            state.itensSelecionados.length > 1
                ? translate('remover_itens')
                : translate('remover_item');

        const formatarTotalPaginas = totalItens =>
            totalItens > 1
                ? `${totalItens} ${translate('dados')}`
                : `${totalItens} ${translate('dado')}`;

        function consultarDados() {
            const carList = state.dados
                .filter(item => item.tipo === 'CAR')
                .map(item => item.value);
            const cpfCnpjList = state.dados
                .filter(item => item.tipo === 'CPF' || item.tipo === 'CNPJ')
                .map(item => item.value);

            if (carList.length === 0 && cpfCnpjList.length === 0) {
                return notifyError('sem_dados');
            }

            services
                .consultarDenuncias({ carList, cpfCnpjList })
                .then(({ data }) => {
                    if (data.denuncia.resultado === 'Positivo') {
                        adicionarResultado(
                            data?.denuncia?.dadosDenuncias || []
                        );
                    }
                    state.resultado = data.denuncia.resultado;
                    state.quantidadeResultados = new Set(
                        data.denuncia.dadosDenuncias.map(d => d.numeroContrato)
                    ).size;
                })
                .catch(error => {
                    return notifyError(error.message);
                });
        }
        return {
            state,
            listaDados,
            formatarTotalPaginas,
            handleSortChangeData,
            translate,
            mudarPaginaDados,
            consultarDados,
            formatarRemover,
            confirmarRemocao,
            handleSelectionChange,
            formatarMensagemResultado
        };
    },
    methods: {
        retornarListagem() {
            this.$router.push({
                name: 'denuncias'
            });

            this.state.resultado = null;
            this.state.quantidadeResultados = 0;
        }
    },

    beforeUnmount() {
        this.state.resultado = null;
        this.state.quantidadeResultados = 0;
    }
});
</script>

<style lang="scss">
.denuncia-resultado {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__mensagem {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        height: 42px;
        width: 100%;
        margin-top: 8px;

        & i {
            font-size: 28px;
            width: 42px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top-left-radius: $default-border-radius;
            border-bottom-left-radius: $default-border-radius;
        }

        &--negativo {
            background-color: #e0ebc8;
            border-radius: $default-border-radius;

            & i {
                color: #3d963c;
                background-color: #c1e083;
            }
        }

        &--positivo {
            background-color: #f8d7da;
            border-radius: $default-border-radius;

            & i {
                color: #a94442;
                background-color: #f0b3b2;
            }
        }
    }
}

.denuncia-inserir {
    & .tabela-dados {
        &__table {
            border-top-left-radius: $default-border-radius;
            border-top-right-radius: $default-border-radius;
            width: 100%;
            min-height: 300px;
        }

        &__empyt svg {
            width: 98px !important;
        }

        .paginacao {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            background-color: $white;
            border-bottom-left-radius: $default-border-radius;
            border-bottom-right-radius: $default-border-radius;
            padding: 15px;

            .number.active {
                background-color: $primary !important;
                border-radius: $default-border-radius;
                color: $white;
            }

            .total-paginas {
                color: $primary;
                font-weight: bold;
            }
        }

        & .acoes {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            margin-top: 20px;

            &__remover {
                display: flex;
                align-items: center;
                font-size: 16px;
                color: red;
                margin: 0 10px;
                cursor: pointer;
                height: 20px;

                span {
                    text-decoration: underline;
                    margin-left: 5px;
                }

                &--disabled {
                    cursor: not-allowed;
                    color: #545454 !important;
                }
            }

            &__icon {
                font-size: 20px;
                line-height: 20px;

                &--consulta {
                    width: 18px;
                    height: 18px;

                    &::before {
                        width: 18px;
                        height: 18px;
                    }
                }
            }

            &__text {
                font-weight: bold;
            }
        }
    }
}
</style>
